__webpack_require__.p = "https://osscdn.zhongheschool.com/frontend/assets/web/2024_5_8_14_5_43/";